/* ---------- ColorCode ---------- */
var COLOR_CODE_VALUES = ['primary-default', 'success-default', 'expose-default', 'warning-default', 'primary-light', 'success-light', 'expose-light', 'warning-light', 'primary-medium', 'success-medium', 'expose-medium', 'warning-medium', 'primary-dark', 'success-dark', 'expose-dark', 'warning-dark', 'muted-default', 'amplified-default', 'greyscale-level-1', 'greyscale-level-2', 'greyscale-level-3', 'greyscale-level-4', 'greyscale-level-5', 'greyscale-level-6', 'foreground-passive-neutral-inverse', 'foreground-passive-neutral-high-idle', 'foreground-passive-neutral-subtle-idle', 'foreground-passive-primary-prominent', 'foreground-passive-success-prominent', 'foreground-passive-warning-prominent', 'foreground-passive-error-prominent'];

/** Union of color token literals (replacement for enum *type*). */

/** Canonical runtime object (string-literal enum replacement). */
var COLOR_CODE = {
  Primary: 'primary-default',
  PrimaryMedium: 'primary-medium',
  PrimaryLight: 'primary-light',
  PrimaryDark: 'primary-dark',
  Success: 'success-default',
  SuccessMedium: 'success-medium',
  SuccessLight: 'success-light',
  SuccessDark: 'success-dark',
  Expose: 'expose-default',
  ExposeMedium: 'expose-medium',
  ExposeLight: 'expose-light',
  ExposeDark: 'expose-dark',
  Warning: 'warning-default',
  WarningMedium: 'warning-medium',
  WarningLight: 'warning-light',
  WarningDark: 'warning-dark',
  Muted: 'muted-default',
  Amplified: 'amplified-default',
  GreyscaleLevel1: 'greyscale-level-1',
  GreyscaleLevel2: 'greyscale-level-2',
  GreyscaleLevel3: 'greyscale-level-3',
  GreyscaleLevel4: 'greyscale-level-4',
  GreyscaleLevel5: 'greyscale-level-5',
  GreyscaleLevel6: 'greyscale-level-6',
  ForegroundPassiveNeutralInverse: 'foreground-passive-neutral-inverse',
  ForegroundPassiveNeutralHighIdle: 'foreground-passive-neutral-high-idle',
  ForegroundPassiveNeutralSubtleIdle: 'foreground-passive-neutral-subtle-idle',
  ForegroundPassivePrimaryProminent: 'foreground-passive-primary-prominent',
  ForegroundPassiveSuccessProminent: 'foreground-passive-success-prominent',
  ForegroundPassiveWarningProminent: 'foreground-passive-warning-prominent',
  ForegroundPassiveErrorProminent: 'foreground-passive-error-prominent'
};

/** Optional: keys of the shim object (if anyone typed against them). */

/** @deprecated Use COLOR_CODE.<Key> at runtime */
var ColorCodeShim = COLOR_CODE;

/* ---------- Directions ---------- */
var DIRECTIONS_VALUES = ['vertical', 'horizontal'];
/** @deprecated Use DirectionsType or DIRECTIONS */
var DIRECTIONS = {
  Vertical: 'vertical',
  Horizontal: 'horizontal'
};

export { COLOR_CODE, COLOR_CODE_VALUES, ColorCodeShim as ColorCode, ColorCodeShim, DIRECTIONS, DIRECTIONS_VALUES };
//# sourceMappingURL=ui.js.map
